// Check if the page has main product div
if (document.querySelectorAll('.bndlr-inner-products-container')) {
  // Check if the page has product container
  if (document.querySelectorAll('.bndlr-product')) {
    // Check if it has product bundler div 
    var productBlocks = document.querySelectorAll('.bndlr-product');
    if (productBlocks.length > 0) {
      // Create a parent Div
      var parentDiv = document.createElement('div');
      parentDiv.setAttribute('id', 'parent-bndlr-product');
      console.log(parentDiv)

      // Add all .bndlr-product divs elements to the parent div 
      productBlocks.forEach(block => {
        parentDiv.appendChild(block);
      });

      // Append the parentDiv to the .bndlr-inner-products-container
      var innerProductsContainer = document.querySelector('.bndlr-inner-products-container');
      innerProductsContainer.appendChild(parentDiv);
    }
  }
}
